import { lazyLoad } from 'utils/loadable';

export const EconomicsPage = lazyLoad(
  () => import('app/components/pages/EconomicsPage/index'),
  (module) => module.EconomicsPage,
);
